/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Autocomplete,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers';
import AppConst from '../AppLayout/const';
import { getFilterSpecialty, getProductSamplingReport } from '../../api/weeklyProductReportApi';

export default function ProductSamplingReportModal() {
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);

  const defaultFilter = {
    from: moment().format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
    specialty: [{ label: 'ALL', value: null }],
  };

  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [filterForm, setFilterForm] = useState(defaultFilter);

  const loadSpecialtyOptions = async () => {
    const response = await getFilterSpecialty();
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.specialty,
        label: row.specialty,
      }));

      setSpecialtyOptions([{ label: 'ALL', value: null }, ...dropdownValue]);

      if (dropdownValue.length < 2) {
        setFilterForm({ ...filterForm, specialty: [dropdownValue[0]] });
      } else {
        setFilterForm({ ...filterForm, specialty: [{ label: 'ALL', value: null }] });
      }
    }
  };

  useEffect(() => {
    if (toggleModal?.url === 'report/product_sampling_report') {
      loadSpecialtyOptions();
      setToggle(true);
    }
  }, [toggleModal]);

  const handleExport = async () => {
    try {
      toast.loading('Please wait ...');
      const request = {
        department: '',
        head_id: '',
        manager_id: '',
        rep_id: '',
        keyword: '',
        from: filterForm?.from,
        to: filterForm?.to,
        specialty:
          filterForm?.specialty.filter((item) => item.value === null).length > 0
            ? []
            : filterForm?.specialty.map((row) => row.value).sort(),
      };
      const res = await getProductSamplingReport(request);

      const { code, result } = res.data.response;
      if (code === '200') {
        window.location.href = result;
        toast.success(`Successfully downloaded file: ${res?.data?.response?.file_name}`);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleChangeFrom = (value) => {
    setFilterForm({ ...filterForm, from: moment(value).format('YYYY-MM-DD') });
  };

  const handleChangeTo = (value) => {
    setFilterForm({ ...filterForm, to: moment(value).format('YYYY-MM-DD') });
  };

  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
  };

  return (
    <Dialog open={toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Product Sampling Report</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid md={12}>
            <Autocomplete
              id='specialty'
              multiple
              fullWidth
              options={specialtyOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={Array.isArray(filterForm.specialty) ? filterForm.specialty : []}
              noOptionsText='No Specialties'
              onChange={(event, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [specialtyOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [specialtyOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== specialtyOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  specialty: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='Specialty' fullWidth />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
          <Grid xs={6}>
            <DatePicker
              label='from'
              views={['month', 'day', 'year']}
              value={filterForm?.from}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='From' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeFrom(value)}
            />
          </Grid>
          <Grid xs={6}>
            <DatePicker
              label='to'
              views={['month', 'day', 'year']}
              value={filterForm?.to}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
              onChange={(value) => handleChangeTo(value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleExport}>Submit</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
